import { useState, useEffect } from "react";

const DEFAULT_TIMEOUT_MS = 500;

/**
 *
 * @param {*} data - The data we're waiting for (e.g. quoteData)
 * @param {string|number} resetKey - When this changes, the timeout resets (e.g. stock?.id)
 * @param {number} [timeoutMs=500] - Max time to show shimmer when data is missing
 * @returns {boolean} true when shimmer should be shown
 */
export default function useShimmerTimeout(
  data,
  resetKey,
  timeoutMs = DEFAULT_TIMEOUT_MS
) {
  const [timeoutExpired, setTimeoutExpired] = useState(false);

  useEffect(() => {
    if (data != null) {
      setTimeoutExpired(true);
      return;
    }
    setTimeoutExpired(false);
    const t = setTimeout(() => setTimeoutExpired(true), timeoutMs);
    return () => clearTimeout(t);
  }, [resetKey, data, timeoutMs]);

  return data == null && !timeoutExpired;
}
